import { TextareaAutosize } from '@mui/material'
import { useState } from 'react'
import styles from './AddEmpPosition.module.scss'

import { Button } from 'components'
import Dropdown from 'components/Dropdown/Dropdown'
import { useDispatch } from 'react-redux'
import { createPositionToStructure } from 'service/StructureService'
import { setNewPosition } from 'store/slices/StructureSlice'
import Notification from 'utils/Notifications'
import { ScaleLoader } from "react-spinners";
import { useTranslation } from 'react-i18next'
const AddEmpPosition = ({ structure_name, id, setRender }) => {
  const { t } = useTranslation('common')

  const [loader, setLoader] = useState(false);
  const [id2, setId2] = useState('')
 
  const [type_doc, setType_doc] = useState('')
  const request_type = [
    { id: 0, label: 'Основной' },
    { id: 1, label: 'Совмещение' },
  ]

  const [positionName, setPositionName] = useState('')
  const [bet, setBet] = useState('')

  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const dispatch = useDispatch()

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (positionName === '') {
      setNotify({
        isOpen: true,
        message: t('structure.position.no_name', 'Вы не ввели название должности'),
        type: 'warning',
        sound: 'warning',
      })
    } else if (bet === '') {
      setNotify({
        isOpen: true,
        message: t('structure.position.no_bet', 'Вы не выбрали ставку'),
        type: 'warning',
        sound: 'warning',
      })
    } else if (type_doc === '') {
      setNotify({
        isOpen: true,
        message: t('structure.position.no_state', 'Вы не выбрали штат'),
        type: 'warning',
        sound: 'warning',
      })
    } else
      try {
        setLoader(true);
        let title = positionName
        let state = type_doc
        let wage = parseInt(bet)
        await createPositionToStructure(structure_name, id, {
          title,
          state,
          wage,
        })
        dispatch(
          setNewPosition({
            title: positionName,
            state: type_doc,
            wage: bet,
          }),
        )

        setNotify({
          isOpen: true,
          message: t('structure.position.added', 'Должность успешно добавлена'),
          type: 'success',
          sound: 'success',
        })

        setRender(true)
      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error', 'Ошибка'),
          type: 'error',
          sound: 'error',
        })
      }finally {
        setLoader(false);
      }
  }

  return (
    <div className={styles.add_emp_position_wrapper}>
       <br></br>
      <div className={styles.flex_col}>
       
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <h4>{t('archive.col_position')}</h4>
          <TextareaAutosize
            id="positionName"
            name="positionName"
            className={styles.type_input}
            value={positionName}
            onChange={(e) => setPositionName(e.target.value)}
            placeholder={t('auto.emppositionform_addempposition.k1')}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <h4>{t('employees.rate')}</h4>
          <TextareaAutosize
            id="positionName"
            name="positionName"
            className={styles.stavka_input}
            value={bet}
            onChange={(e) => {
              const value = e.target.value;
              if (!isNaN(value)) {
                setBet(value);
              }
            }}
            placeholder={t('auto.emppositionform_addempposition.k2')}
          />
          
        </div>

        <div
          style={{ display: 'flex', flexDirection: 'column', width: '180px' }}
        >
          <h4>{t('europass.staff')}</h4>
          <Dropdown
            setId={setId2}
            setType={setType_doc}
            title={'Выбрать'}
            data={request_type ?? []}
          />
        </div>
    
      </div>
      {loader ? (
            <ScaleLoader color="black" size={30} />
          ) : (
            <Button className={styles.add_pos} onClick={handleSubmit}>
            {' '}
            Добавить{' '}
          </Button>
          )}
      
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default AddEmpPosition
